module.exports = __webpack_public_path__ + "static/media/KaTeX_Math-BoldItalic.b3e80ff3.woff";